import { render } from "./RegisterButtonPage.vue?vue&type=template&id=4df7fe39&scoped=true"
import script from "./RegisterButtonPage.vue?vue&type=script&lang=js"
export * from "./RegisterButtonPage.vue?vue&type=script&lang=js"

import "./RegisterButtonPage.vue?vue&type=style&index=0&id=4df7fe39&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df7fe39"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading});
